module.exports = "/assets/site/images/membershipfees-header-image.jpg?1c272a8c013c595871e6ce7e995eb239";